import classnames from 'classnames';
import styles from './styles';

interface PlusIconProps {
  isRotated?: boolean;
}

const PlusIcon = ({ isRotated = false }: PlusIconProps): JSX.Element => {
  return (
    <span className="plus-icon-outer-container">
      <span className="plus-icon-inner-container">
        <span
          data-testid={'plus-icon'}
          className={classnames('plus-icon', isRotated ? 'rotated' : 'unrotated')}
        ></span>
      </span>
      <style jsx>{styles}</style>
    </span>
  );
};
export default PlusIcon;
